export const API_ROOT = '/install-portal';
export const V1 = '/v1.0';

export const SPLIT_CHAR = '-';



// WEBPACK FOOTER //
// ./src/constant/apiConstants.js